import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React from 'react';

import { Flex, Text } from '~/components/blocks';
import { PatientTypeIcon } from '~/components/partials';

type Props = {
  hasApp: boolean;
  hasSms: boolean;
  hasLine: boolean;
  isDeactivatedPatient: boolean;
  isDeactivatedLineVisitor: boolean;
};

const Content = styled(Flex)(({ theme }) =>
  css({
    backgroundColor: theme.colors.background.bg,
    borderRadius: theme.radii.half,
    padding: `${theme.space.xs} ${theme.space.m}`,
    height: '100%',
    width: 'fit-content',
    textAlign: 'center',
    alignItems: 'center',
    marginTop: theme.space.s,
    marginRight: theme.space.s,
  }),
);

export const ContactMethods = (props: Props) => {
  const { hasApp, hasSms, hasLine, isDeactivatedPatient, isDeactivatedLineVisitor } = props;

  return (
    <Flex>
      {hasApp && (
        <Content>
          <PatientTypeIcon isPatient={true} size="l" />
          <Text size="s">{`アプリ${isDeactivatedPatient ? '（退会済み）' : ''}`}</Text>
        </Content>
      )}
      {hasLine && (
        <Content>
          <PatientTypeIcon isLine={true} size="l" />
          <Text size="s">{`LINE${isDeactivatedLineVisitor ? '（送信不可）' : ''}`}</Text>
        </Content>
      )}
      {hasSms && (
        <Content>
          <PatientTypeIcon isPatient={false} size="l" />
          <Text size="s">SMS</Text>
        </Content>
      )}
    </Flex>
  );
};
